<template>
    <div class="row m-0" style="height: 100%">
        <div class="col-7 chart-area">
            <TrendChart
                v-if="events"
                :chartData="totalLog"
                :pointInfo="pointInfo"
                :abnormalData="events.abnormalEvents"
                :abnormalDefs="events.abnormalDefs"
                :missingData="events.missingEvents"
                :uesType="'totalLog'"
            />
        </div>
        <div class="col-5 table-area">
            <div class="table-wrapper">
                <div class="col-12">
                    <div class="table-title-wrap">
                        <span class="section-title">{{ "데이터" }}</span>
                        <div class="rightWrapper">
                            <span>{{ "📢 보정후 데이터는 이상값이나 데이터 결측이 아닐 경우는 계측값입니다." }}</span>
                            <div class="split"></div>
                            <div ref="downloadBtn" class="dataDownloadIcon" @click="animateIcon">
                                <i ref="forwardIcon" class="material-icons forwardIcon"> forward </i>
                                <i class="material-icons removeIcon"> remove </i>
                            </div>
                        </div>
                    </div>
                    <TotalLogTable
                        :data="totalLog"
                        :unit="unit"
                        :downloadFlag="downloadFlag"
                        @update:downloadFlag="setDownloadFlag(false)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TrendChart from "../chart/TotalLogChart.vue";
import TotalLogTable from "../table/TotalLogTable.vue";
export default {
    props: {
        totalLog: { type: Array, default: () => [] },
        pointInfo: { type: Object, default: () => {} },
        events: { type: Object, default: () => {} },
        unit: { type: String, default: "" },
    },
    data() {
        return {
            downloadFlag: false,
        };
    },
    components: {
        TrendChart,
        TotalLogTable,
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        setDownloadFlag(flag) {
            this.downloadFlag = flag;
        },
        animateIcon() {
            const icon = this.$refs.forwardIcon;
            if (!icon) return;

            this.setDownloadFlag(false);

            this.$nextTick(() => {
                this.setDownloadFlag(true);
            });
            icon.classList.add("shake");

            setTimeout(() => {
                icon.classList.remove("shake");
            }, 600);
        },
    },
};
</script>

<style scoped>
.chart-area {
    height: 100%;
    /* margin-top: 10px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.section-title {
    font-size: 13px;
    font-weight: 600;
    background-color: #3c5b6f;
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 10px;
    min-width: 130px;
    color: white;
}
.table-title-wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
}
.table-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;
}

.table-wrapper {
    display: flex;
    flex: 1;
    /* overflow-y: auto; */
    overflow: hidden;
}
.forwardIcon {
    transform: rotate(90deg);
}
.dataDownloadIcon {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    margin: 0 8px 0 1px;
}
.split {
    border-left: 0.9px solid #eeeeee;
    margin: 1px 5px 1px 9px;
    height: 20px;
}
.dataDownloadIcon .material-icons {
    font-size: 21px;
    margin: -4px 0;
    user-select: none;
}
@keyframes upDownShake {
    0% {
        transform: rotate(90deg) translateX(0);
    }
    20% {
        transform: rotate(90deg) translateX(-3px);
    }
    40% {
        transform: rotate(90deg) translateX(3px);
    }
    60% {
        transform: rotate(90deg) translateX(-3px);
    }
    80% {
        transform: rotate(90deg) translateX(3px);
    }
    100% {
        transform: rotate(90deg) translateX(0);
    }
}

.shake {
    animation: upDownShake 0.6s ease-in-out;
}
.rightWrapper {
    display: flex;
    flex-direction: row;
}
</style>
